
const digest = '625f665b2337299c10170024d282082116154050cc40ceb1efb6afa6105eafc2';
const classes = {"wrapper":"_wrapper_1ukca_1","group":"_group_1ukca_9","title":"_title_1ukca_19","item":"_item_1ukca_23","label":"_label_1ukca_28","request":"_request_1ukca_31"};
const css = `._wrapper_1ukca_1 {
  font-family: Rubik, "sans-serif";
  background: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
}
._wrapper_1ukca_1 ._group_1ukca_9 {
  background: #fff;
  border: 1px solid #ecedf3;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 14px;
  flex-wrap: wrap;
}
._wrapper_1ukca_1 ._group_1ukca_9 ._title_1ukca_19 {
  font-size: 16px;
  font-weight: 600;
}
._wrapper_1ukca_1 ._group_1ukca_9 ._item_1ukca_23 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
._wrapper_1ukca_1 ._group_1ukca_9 ._item_1ukca_23 ._label_1ukca_28 {
  font-weight: 500;
}
._wrapper_1ukca_1 ._request_1ukca_31 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  